import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
export default function SelectionPage() {
  const { lotteryId } = useParams();
  const [data, setData] = useState();
  const [numLen, setNumLen] = useState();
  const [lottery, setLottery] = useState();

  function maskLastTwoChars(input) {
    if (input.length <= 2) {
      return "*".repeat(input.length); // Хэрэв урт нь 2 эсвэл бага байвал бүгдийг од болгоно
    }
    return input.slice(0, -2) + "**"; // Сүүлийн 2-г од болгоно
  }

  useEffect(() => {
    if (!lotteryId) return;
    // console.log("AAAA ==============\n");
    // Функц хүсэлт илгээнэ
    const fetchData = async () => {
      try {
        const lottRepo = await fetch(
          `${process.env.REACT_APP_API_URL}/api/monitor/lottery-reward-selection-active/${lotteryId}`
        );

        const lott = await lottRepo.json();
        setLottery(lott);

        setNumLen(lott.numberLength);
        // console.log("lott --->", lott);

        if (lott.activeRewardId) {
          // const lotteryId = lott.activeRewardId;
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/monitor/${lotteryId}`
          );
          const result = await response.json();
          // console.log("rewardid ---?>", result);
          setData(result);
        }
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    };

    // 5 секунд тутамд хүсэлт илгээнэ
    const intervalId = setInterval(fetchData, 5000);

    // Хуудаснаас гарахад interval-г цэвэрлэх
    return () => clearInterval(intervalId);
  }, []);

  let numberArr = data?.draw?.draw_number?.split("") || [];

  // console.log("data ==============\n", data);
  let dot;
  // console.log("data?.lucky_numbe ==============\n", numberArr.length);
  if (numLen - numberArr.length === 4) {
    dot = "***";
  } else if (numLen - numberArr.length === 3) {
    dot = "**";
  } else if (numLen - numberArr.length === 2) {
    dot = "*";
  } else if (numLen - numberArr.length === 1) {
    dot = "";
  }

  const loopArr = new Array(numLen).fill(null);
  return (
    <div className="wrap">
      <div className="main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <div className="brand mb-3">
                <img src="/frame.png" alt="" className="logo" />
                <div className="brand-title">{lottery?.title}</div>
              </div>

              <div className="" style={{ flex: "1" }}>
                <div className="title">Азын дугаар</div>
                <div className="d-flex gap-4  nubmers ">
                  {loopArr?.map((data, i) => {
                    return (
                      <div className="number">
                        {numberArr?.length > i ? numberArr[i] : ""}
                      </div>
                    );
                  })}
                </div>

                {data?.draw?.winner_info?.phone && (
                  <div className="winner">
                    {" "}
                    🎉 {maskLastTwoChars(data.draw.winner_info?.phone)}
                  </div>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="" style={{ paddingLeft: "90px" }}>
                <div className="possible-table">
                  {/* <tbody> */}
                  {data?.possibleNumbers?.map((pb, key) => {
                    const text = pb.prefix || ""; // prefix string
                    const lastChar = text.slice(-1); // сүүлийн тэмдэгт
                    const rest = text.slice(0, -1); // үлдсэн хэсэг

                    return (
                      <div className="possible-row" key={key}>
                        <div className="possible-label me-4">
                          <span className="prefix-text">{rest}</span>
                          <div className="last-char">{lastChar}</div> {dot}
                        </div>

                        <div
                          className={
                            !pb.possible || pb.possible === 0
                              ? "unpossible"
                              : "possible"
                          }
                        >
                          {pb.possible}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
